import { jsx as _jsx } from "react/jsx-runtime";
import { unmountComponentAtNode, render } from 'react-dom';
export function createConfirmation(Component, props) {
    const { body } = document;
    let wrapper;
    if (body !== null) {
        wrapper = body.appendChild(document.createElement('div'));
    }
    const cleanup = () => {
        unmountComponentAtNode(wrapper);
        return setTimeout(() => wrapper.remove());
    };
    const promise = new Promise((resolve, reject) => {
        try {
            render(_jsx(Component, Object.assign({ cleanup: cleanup, resolve: resolve }, props)), wrapper);
        }
        catch (e) {
            reject(e);
            throw e;
        }
    });
    return promise;
}
//# sourceMappingURL=createConfirmation.js.map